<template>
  <div id="register">
    <a-layout-header
      class="layout-header"
    >
      <a-row justify="end" align="middle">
        <span
          style="margin-right: 60px; cursor: pointer;color: #74562C;font-size: 16px;"
          @click="$router.push('/login')"
        >{{ $t("pages_register_013") }}</span>
        <GlobalOutlined class="ic-global" />
        <language-selector />
      </a-row>
    </a-layout-header>
    <a-layout class="layout-style">
      <a-layout-content>
        <a-row
          v-if="!isInvalid"
          class="register-body flex-align"
          style="height: 100%; align-items: center"
        >
          <div class="register-swiper flex-align">
            <!-- <img :src="themeData.darkLogoListWhite" class="logo"> -->
            <img :src="themeData.bgList" class="bgList">
            <div class="register_text">
              <div v-if="NODE_ENV==='sandbox'" style="color: #fe0202;font-size: 28px;">测试环境，仅供内部使用</div>
              <div class="register_text_title">服务中国卖家 赋能全球贸易</div>
              <img class="register_text_line" src="~@/assets/images/login_line.png">
              <div class="register_text_content">
                无论您的业务布局何处，我们都为您提供坚实可信的依托。<br>
                我们持有国际认可的TCSP信托与公司服务牌照，确保您的跨境架构<br>
                合法、安全、稳健，让您的全球发展之路每一步都安心无忧。
              </div>
            </div>
          </div>
          <div class="card-box">
            <div class="card-register">

              <div class="card-title">{{ $t("pages_register_001") }}</div>
              <div class="card-body">
                <a-form
                  ref="registerRef"
                  layout="vertical"
                  class="register-form ant-round-form"
                  :model="registerForm"
                  :rules="registerRules"
                  @finish="handleRegister"
                >
                  <!-- <a-form-item name="email" :label="$t('pages_register_002')"> -->

                  <!-- <a-form-item name="mobile" :label="$t('pages_register_004')"> -->
                  <a-form-item name="mobile">
                    <div class="flex-align">
                      <a-form-item-rest>
                        <a-select
                          v-model:value="registerForm.areaPhoneCode"
                          :style="{
                            flex: 1,
                            height: '40px',
                          }"
                          show-search
                        >
                          <a-select-option
                            v-for="item in areaCodeList"
                            :key="item"
                            :value="item"
                          >+{{ item }}</a-select-option>
                        </a-select>
                      </a-form-item-rest>
                      <a-input
                        v-model:value="registerForm.mobile"
                        style="flex: 2; margin-left: 24px;height: 40px; line-height: 40px;"
                        :placeholder="$t('pages_register_005')"
                        allow-clear
                      />
                    </div>
                  </a-form-item>
                  <a-form-item name="email">
                    <a-input
                      v-model:value="registerForm.email"
                      :placeholder="$t('pages_register_003')"
                      allow-clear
                      style="height: 40px; line-height: 40px;"
                    />
                  </a-form-item>
                  <!-- <a-form-item
                    name="verificationCode"
                    :label="$t('pages_register_006')"
                  > -->
                  <a-form-item
                    name="verificationCode"
                  >
                    <div class="flex-align">
                      <a-input
                        v-model:value="registerForm.verificationCode"
                        allow-clear
                        :placeholder="$t('pages_register_007')"
                        style="height: 40px; line-height: 40px;"
                      />
                      <a-button
                        type="primary"
                        shape="round"
                        style="margin-left: 24px"
                        class="send-btn"
                        :disabled="countNum > 0"
                        :loading="codeLoading"
                        @click="sendCode"
                      >{{
                        countNum > 0
                          ? `${countNum}${$t("pages_register_011")}`
                          : $t("pages_register_008")
                      }}</a-button>
                    </div>
                  </a-form-item>

                  <!-- <a-form-item
                    v-if="!isReferrer"
                    name="referrer"
                    :label="$t('pages_register_009')"
                  > -->
                  <a-form-item
                    v-if="!isReferrer"
                    name="referrer"
                  >
                    <a-input
                      v-model:value="registerForm.referrer"
                      :placeholder="$t('pages_register_010')"
                      allow-clear
                      style="height: 40px; line-height: 40px;"
                    />
                  </a-form-item>

                  <a-form-item style="margin-top: 48px">
                    <a-button
                      style="width: 100%;height: 40px;border-radius: 0px;"
                      shape="round"
                      type="primary"
                      html-type="submit"
                      :loading="loading"
                      :disabled="!isAgree"
                    >{{ $t("pages_register_001") }}</a-button>
                  </a-form-item>
                  <a-form-item>
                    <a-checkbox v-model:checked="isAgree">
                      <span>{{ $t("pages_register_018") }}</span>
                      <template v-if="saasName !== 'Easyloon'">
                        <a
                          v-for="(x, i) in agreementList"
                          :key="i"
                          :href="`#/agreement/${x.agreementKey}`"
                          target="_blank"
                        >《{{ x.agreementName }}》</a>
                      </template>
                      <template v-else>
                        <a href="#/terms_service" style="color:#BA8438" target="_blank">{{
                          $t("pages_register_019")
                        }}</a>
                        <a href="#/privacy_policy" style="color:#BA8438" target="_blank">{{
                          $t("pages_register_020")
                        }}</a>
                        <!-- <a href="https://fp.easyloon.com/service.html" target="_blank">{{
            $t("pages_register_019")
          }}</a>
          <a href="https://fp.easyloon.com/privacy.html" target="_blank">{{
            $t("pages_register_020")
          }}</a> -->
                      </template>
                    </a-checkbox>
                  </a-form-item>
                  <a-form-item
                    style="text-align: center; margin-top: -18px; font-size: 12px"
                  >
                    <span style="color: #999">{{
                      $t("pages_register_012")
                    }}</span>
                    <span
                      style="cursor: pointer;color: rgba(0, 0, 0, 0.9);"
                      @click="$router.push('/login')"
                    >{{ $t("pages_register_013") }}</span>
                  </a-form-item>
                </a-form>
              </div>
            </div>
          </div>
        </a-row>
        <div v-else class="link-invalid">
          <img src="~@/assets/images/link-invalid.png">
          <div>{{ $t("pages_register_015") }}</div>
        </div>
      </a-layout-content>
    </a-layout>
    <password-set ref="setRef" v-model:visible="visible" />
    <!-- <div class="keep-record">
      <div v-if="themeData.address">{{ themeData.address }}</div>
      <a target="_blank" href="https://beian.miit.gov.cn">{{
        themeData.copyRight
      }}</a>
    </div> -->
  </div>
</template>
<script>
import {
  ref,
  reactive,
  toRefs,
  inject,
  defineComponent,
  onUnmounted
} from 'vue'
import { message } from 'ant-design-vue'
import { useRoute } from 'vue-router'
import PasswordSet from './components/password-set'
import i18n from '@/locale'
import Cookies from 'js-cookie'
import { _login, _user } from '@/api'
import LangSelector from '@/components/lang-sel'
export default defineComponent({
  name: 'Register',
  components: {
    'password-set': PasswordSet,
    'language-selector': LangSelector
  },
  setup() {
    let timer = ref(null)
    const setRef = ref(null)
    const registerRef = ref(null)
    const route = useRoute()

    const agreementList = ref([])
    const saasName = ref(process.env.VUE_APP_SAASNAME)
    const NODE_ENV = ref(process.env.NODE_ENV)

    const state = reactive({
      themeData: inject('$themeData'),
      isAgree: false,
      isInvalid: false,
      visible: false,
      countNum: 0,
      codeLoading: false,
      isReferrer: false,
      linkFlag: false,
      loading: false,
      areaCodeList: [],
      registerForm: {
        email: '',
        areaPhoneCode: '',
        mobile: '',
        verificationCode: '',
        referrer: ''
      },
      registerRules: {
        email: [{ required: true, message: i18n.global.t('pages_register_003') }],
        mobile: [
          { required: true, message: i18n.global.t('pages_register_005') },
          {
            pattern: new RegExp(/^[,\\.#%'\\+\\*\-:;^_`() 0-9A-Za-z]+$/),
            message: i18n.global.t('pages_register_014')
          }
        ],
        verificationCode: [{ required: true, message: i18n.global.t('pages_register_007') }]
        // referrer: [{ required: true }]
      }
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    const sendCode = async () => {
      registerRef.value
        .validateFields('email')
        .then(() => {
          state.codeLoading = true
          return _login.getEmailVerificationCode({
            email: state.registerForm.email
            // areaPhoneCode: state.registerForm.areaPhoneCode
          })
        })
        .then((res) => {
          state.codeLoading = false
          if (res.data.succ) {
            state.countNum = 60
            timer = setInterval(() => {
              state.countNum--
              if (state.countNum === 0) clearInterval(timer)
            }, 1000)
          } else {
            message.error(res.data.resMsg)
          }
        })
        .catch((err) => console.log(err))
    }

    const handleRegister = async () => {
      state.loading = true
      const res = await _login.checkUserInfo(state.registerForm)
      state.loading = false
      if (res.data.succ) {
        const recommendCode = Cookies.get('recommendCode')
        const fromRegister = Cookies.get('fromRegister')
        if (fromRegister) state.from = fromRegister
        if (recommendCode && !state.registerForm.referrer) {
          state.registerForm.referrer = recommendCode
        }
        const params = Object.assign({}, state.registerForm, {
          verificationCodeUuid: res.data.data,
          linkFlag: state.linkFlag,
          from: state.from === 'undefined' || !state.from ? null : state.from
        })
        setRef.value.initParams(params)
        state.visible = true
      } else {
        message.error(res.data.resMsg)
      }
    }

    const loadPhoneAreaCode = async () => {
      const res = await _user.getPhoneAreaCode()
      if (res.data.succ) {
        const areaCodeList = []
        for (const item of res.data.data) {
          if (item === '86') state.registerForm.areaPhoneCode = item
          areaCodeList.push(item)
        }
        state.areaCodeList = areaCodeList
        // state.areaCodeList = ['86']
        if (!state.registerForm.areaPhoneCode) {
          state.registerForm.areaPhoneCode = areaCodeList[0]
        }
      }
    }

    const loadSalesReferralCode = async (recommendUrl) => {
      if (recommendUrl) {
        const res = await _login.getRegisterUser({ recommendUrl })
        if (res.data.succ) {
          const { from, recommendCode } = res.data.data
          if (from) state.from = from
          if (recommendCode) {
            state.isReferrer = true
            state.registerForm.referrer = recommendCode
            state.linkFlag = true
          }
        } else if (res.data.resCode === '010055') {
          state.isInvalid = true
        }
      }
    }

    const getSaasMerAgreement = async () => {
      const res = await _user.getSaasMerAgreement({})
      if (res.data.succ) {
        agreementList.value = res.data.data
      }
    }

    const init = () => {
      const { key } = route.query
      loadPhoneAreaCode()
      loadSalesReferralCode(key)
      process.env.VUE_APP_SAASNAME !== 'Easyloon' && getSaasMerAgreement()
    }

    init()

    return {
      setRef,
      registerRef,
      saasName,
      agreementList,
      NODE_ENV,
      handleRegister,
      sendCode,
      ...toRefs(state)
    }
  }
})
</script>
<style lang="less" scoped>
#register {
  .scrollbar-none;
  background: #f8f9fb;
  height: 100vh;
  overflow-y: scroll;
  .ic-global {
    color: #74562C;
  }
  .layout-header {
    background: #f8f9fb;
    position: absolute;
    top: 2%;
    right: 100px;
  }

  .logo {
    width: 180px;
  }
  .register-body {
    box-shadow: 0px 2px 9px 6px rgba(245, 245, 245, 0.5);
    border-radius: 8px;
    .register-img {
      flex: 1.5;
      overflow: hidden;
      img {
        width: 484px;
        height: 440px;
      }
    }
    .register-swiper {
      height: 100%;
      align-items: flex-start;
      position: relative;
      width: 52%;
      .logo {
        position: absolute;
        width: 184px;
        top: 40px;
        left: 100px;
      }
      .bgList {
        width: 100%;
        height: 100%;
      }
      .register_text {
        width: 96%;
        position: absolute;
        bottom: 19.5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .register_text_line{
          width: 96%;
          height: 1px;
        }
        .register_text_title {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #74562C;
          line-height: 50px;
          text-align: center;
          margin-bottom: 10px;
        }

        .register_text_content {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #8E6935;
          line-height: 28px;
          text-align: center;
          margin-top: 10px;

          @media (max-width: 1600px) {
            font-size: 12px;
          }
        }
      }
    }

    .card-box{
      width: 48%;
      display: flex;
      justify-content: center;
      .card-register {
      text-align: left;
      background: #fff;
      box-shadow: 2px 2px 10px 0px #DCDCDC;
      border-radius: 8px;
      padding: 40px;
      position: relative;
      width: 480px;
      height: 580px;
      .card-title{
      font-size: 36px;
      font-weight: 600;
    }
      .card-body {
        margin-top: 40px;
        .send-btn {
          width: 128px;
          border-radius: 0px;
          height: 40px;
          background: @table-th-color;
          border: none;
          color: #000;
        }
      }
    }
    }
  }
  .link-invalid {
    margin-top: 188px;
    img {
      width: 100px;
    }
  }
  .keep-record {
    text-align: center;
    color: #9c9d9c;
    padding-top: 128px;
    a {
      color: #9c9d9c;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}
#resetPassword::-webkit-scrollbar {
  display: none;
}
@media (max-width: 768px) {
  #register {
    font-size: 16px;

    .register-swiper {
      display: none;
    }

    .register-body {
      .card-box {
        width: 100%;

        .card-register {
          padding: 25px;

          .card-body {
            margin: 10px 0 0 10px;
          }

          margin-left: 5%;
          margin-right: 5%;

          .ant-form-item {
            margin: 0 0 10px;
          }
        }
      }
    }

    .layout-header {
      top: 10px;
      right: 10px;
    }
  }
}
</style>
